import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-labels",
  "use": "icon-menu-labels-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-labels\">\n    <path d=\"M5 13L5 11C5 10.4477 5.44772 10 6 10L18 10C18.5523 10 19 10.4477 19 11L19 13C19 13.5523 18.5523 14 18 14L6 14C5.44772 14 5 13.5523 5 13Z\" stroke=\"currentColor\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol